<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="impersonation-dialog"
  header="Impersonate User"
  [style]="{ width: '480px' }"
  (onHide)="onCancel()">

  <div class="flex flex-col gap-4">
    <p class="text-sm text-gray-600 m-0">
      Enter a Windows login ID to search for a user to impersonate.
      API calls will use the selected user's profile.
    </p>

    <div class="flex flex-col gap-1">
      <label for="impersonation-search" class="text-sm font-medium text-gray-700">
        Windows Login ID
      </label>
      <div class="relative">
        <i class="pi pi-search search-icon"></i>
        <input
          id="impersonation-search"
          pInputText
          type="text"
          class="w-full pl-8"
          placeholder="e.g. jsmith"
          [formControl]="searchControl" />
      </div>
      <span class="text-xs text-gray-500">Minimum 2 characters</span>
    </div>

    @if (loading()) {
      <div class="flex justify-center py-4">
        <p-progressspinner
          styleClass="w-8 h-8"
          strokeWidth="4"
          animationDuration=".8s" />
      </div>
    }

    @if (error()) {
      <div class="flex items-center gap-2 text-red-600 text-sm bg-red-50 p-3 rounded-lg">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ error() }}</span>
      </div>
    }

    @if (!loading() && results().length > 0) {
      <p-listbox
        [options]="results()"
        [formControl]="selectedControl"
        optionLabel="fullName"
        dataKey="userId"
        styleClass="results-listbox"
        [listStyle]="{ 'max-height': '240px' }">
        <ng-template #item let-user>
          <div class="flex items-center gap-3 w-full">
            <div class="user-avatar">
              <i class="pi pi-user"></i>
            </div>
            <div class="flex flex-col text-left">
              <span class="font-medium text-gray-900 text-sm">{{ user.fullName }}</span>
              <span class="text-xs text-gray-500">{{ user.userName }}</span>
            </div>
          </div>
        </ng-template>
      </p-listbox>
    }

    @if (!loading() && searched() && results().length === 0 && !error()) {
      <div class="flex flex-col items-center gap-2 py-6 text-gray-500">
        <i class="pi pi-search text-2xl"></i>
        <span class="text-sm">No users found for "{{ searchControl.value }}"</span>
      </div>
    }
  </div>

  <ng-template #footer>
    <p-button
      label="Cancel"
      severity="secondary"
      [text]="true"
      (onClick)="onCancel()" />
    <p-button
      label="Impersonate"
      [disabled]="!selectedUser()"
      (onClick)="onConfirm()" />
  </ng-template>
</p-dialog>
